import { gql } from '@apollo/client';

export const ALL_INSIGHTS_PAGED = gql`
  query AllInsightsPaged($input: getInsightsInput!) {
    insights: allInsightsPaged(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          image
          serviceProvider {
            id
            name
          }
          funder {
            id
            name
          }
          institution {
            id
            name
          }
          users {
            id
            firstName
            lastName
          }
          tags {
            id
            name
          }
          url
          createdBy {
            id
            firstName
            lastName
          }
          createdOn
          isFavorite
          organisations {
            id
            users {
              id
            }
            organisation {
              id
              isInstitution
              isFunder
              isServiceProvider
              funder {
                id
                name
              }
              institution {
                id
                name
              }
              serviceProvider {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
